import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato", { description: "Ti risponderemo al più presto." });
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Errore", { description: "Riprova più tardi." });
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="contact-page" className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <span className="overline">Contatti</span>
        <h1 className="font-serif text-5xl mt-4 tracking-tight leading-tight">Scrivici.</h1>
        <p className="text-sm text-alimi-inkSoft leading-relaxed mt-6 max-w-md">
          Hai una richiesta speciale, un'idea per un pezzo personalizzato o vuoi semplicemente
          salutarci? Saremo felici di leggerti.
        </p>
        <div className="mt-10 space-y-4 text-sm text-alimi-inkSoft">
          <div>
            <div className="overline mb-1">Email</div>
            <div>hello@alimi.it</div>
          </div>
          <div>
            <div className="overline mb-1">Instagram</div>
            <div>@alimi.creazioni</div>
          </div>
          <div>
            <div className="overline mb-1">Atelier</div>
            <div>Su appuntamento — Italia</div>
          </div>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
        <div>
          <label className="overline block mb-2">Nome</label>
          <input
            data-testid="contact-name"
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm"
          />
        </div>
        <div>
          <label className="overline block mb-2">Email</label>
          <input
            data-testid="contact-email"
            required
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm"
          />
        </div>
        <div>
          <label className="overline block mb-2">Messaggio</label>
          <textarea
            data-testid="contact-message"
            required
            rows={6}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full px-4 py-3 bg-alimi-surface border border-alimi-border focus:border-alimi-ink outline-none text-sm resize-none"
          />
        </div>
        <button data-testid="contact-submit" type="submit" className="btn-primary" disabled={sending}>
          {sending ? "Invio…" : "Invia messaggio"}
        </button>
      </form>
    </div>
  );
}
